import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Alert, AlertProps, Theme } from 'localmed-core';
import React, { Component, ComponentProps } from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { DisplayErrorState } from './types';
import { coalesceFieldErrors, shouldDisplayErrors } from './utils';

type Props = Omit<AlertProps, 'children'> & {
  name: string;
  displayErrorState?: DisplayErrorState;
  showAllErrors?: boolean;
};

const ErrorList = styled('ol')<ComponentProps<'ol'>, Theme>(
  ({ theme }) => css`
    margin: 0;
    padding-left: ${theme.space.md};
  `
);

export default class FieldError extends Component<Props> {
  static defaultProps = {
    tier: 'error',
    subtle: true,
    showAllErrors: false,
  };

  render() {
    const { name, displayErrorState, showAllErrors, ...props } = this.props;
    return (
      <Field
        name={name}
        subscription={{
          dirty: true,
          touched: true,
          error: true,
          submitError: true,
          dirtySinceLastSubmit: true,
        }}
      >
        {({ meta }: FieldRenderProps) => {
          if (!shouldDisplayErrors(meta, displayErrorState)) {
            return null;
          }
          const errors = coalesceFieldErrors(meta);

          if (errors.length === 0) {
            return null;
          }
          return (
            <Alert fontSize="xs" {...props}>
              {showAllErrors && errors.length > 1 ? (
                <ErrorList>
                  {errors.map((error) => (
                    <li key={error.message}>{error.message}</li>
                  ))}
                </ErrorList>
              ) : (
                errors[0].message
              )}
            </Alert>
          );
        }}
      </Field>
    );
  }
}
